/* global JSX */
// ListCardRow
// ***********************************************************************************************************************
import { Grid } from "@mui/material";
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { EllipsisTypography } from "../../Typography/EllipsisTypography";

// ListCardValueRow
export interface IListCardColData {
    size?: number;
    style?: any;
    title?: string | JSX.Element;
    titleClasses?: string;
    value?: string | JSX.Element;
    valueClasses?: string;
    tooltip?: string;
}

export interface IListCardRowData {
    style?: any;
    cols?: IListCardColData[];
    content?: string | JSX.Element;
    contentClasses?: string;
    tooltip?: string;
}

export interface IListCardRowProp extends IListCardRowData {
    id?: string;
    checked?: boolean;
    index: number;
    onCheckboxChange?: (id: string, checked: boolean) => void;
}

export class ListCardRow extends React.Component<IListCardRowProp, {}> {
    handleCheckboxChange = (e) => {
        const props = this.props;
        e.stopPropagation();
        if (!props.id) return;
        props.onCheckboxChange(props.id, e.target.checked);
    };

    render() {
        const props = this.props;
        const stringContent = !!props.content && typeof props.content === "string";
        const cols = props.cols ? props.cols : [];
        return (
            <Grid container spacing={1} title={props.tooltip ?? (stringContent ? props.content : "")} sx={props.index === 0 ? null : { marginTop: "1rem" }}>
                {cols.map((col, i) =>
                    <Grid item key={i} sm={col.size ?? 12} style={col.style} title={col.tooltip ?? (!Base.isNullOrUndefined(col.value) && typeof col.value === "string" ? col.value : "")}>
                        {col.title
                            ? (typeof col.title === "string"
                                ? <EllipsisTypography variant="caption" component="p" title={col.title}>
                                    {!!props.onCheckboxChange && i === 0 &&
                                        <input type="checkbox" className="cardCb" checked={props.checked} onClick={this.handleCheckboxChange} value="" />
                                    }
                                    {col.title}
                                </EllipsisTypography>
                                : col.title)
                            : null
                        }
                        {!Base.isNullOrUndefined(col.value)
                            ? (typeof col.value === "string"
                                ? <EllipsisTypography sx={{ minHeight: "20px" }} title={col.value}>{col.value}</EllipsisTypography>
                                : col.value)
                            : null
                        }
                    </Grid>
                )}
                {props.content
                    ? (stringContent
                        ? <div className={"value" + (props.contentClasses ? " " + props.contentClasses : "")} title={props.content}>{props.content}</div>
                        : props.content)
                    : null
                }
            </Grid>
        );
    }
}